import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Drawer, Table, Dropdown, Checkbox, Tag, Select, Popover, Tooltip, Divider,
} from 'antd';
import { FilterOutlined, ControlOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate, entityNameEnum, filterTypeEnums } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import PaymentOutgoingActions from '@Actions/paymentOutgoingActions';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import SellerActions from '@Actions/sellerActions';
// import ViewPayment from '@Components/Common/ViewPayment';
import SelectSeller from '@Components/Common/SelectSeller';
import PaymentModeActions from '@Actions/configurations/paymentModeAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ViewOutgoingPayment from '../ViewOutgoingPayment';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

const fixedColumns = ['DATE', 'VENDOR', 'VENDOR'];

function OutgoingPaymentsList({
  getPaymentsOutgoingLoading, paymentOutgoing, getPaymentsOutgoing, user, history, location, downloadPaymentOutgoingLoading,
  customFieldsProps, getDocCFV2, getDocCFV2Success, getSellers, sellers, MONEY, getPaymentMode, paymentModeResults, downloadPaymentOutgoing,

}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState('');
  const [selectedTenantIds, setSelectedTenantIds] = useState('');
  const [selectedSeller, setSelectedSeller] = useState('');
  const [showViewPayout, setShowViewPayout] = useState('');
  const [selectedPayment, setSelectedPayment] = useState('');
  const [selectedPaymentType, setSelectedPaymentType] = useState('OUTGOING');
  const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState('');
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [selectedPaymentNew, setSelectedPaymentNew] = useState(null);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-payout') ? JSON.parse(localStorage.getItem('prcz-page-columns-payout')) : {
    DATE: {
      label: 'Date',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    REFERENCE_CODE: {
      label: 'Reference #',
      visible: true,
    },
    VENDOR: {
      label: 'Vendor',
      visible: true,
    },
    MODE: {
      label: 'Mode',
      visible: true,
    },
    PAYMENT_STATUS: {
      label: 'Payment Status',
      visible: true,
    },
    APPROVAL_STATUS: {
      label: 'Approval Status',
      visible: true,
    },
    AMOUNT: {
      label: 'Amount',
      visible: true,
    },
    UNUSED_AMOUNT: {
      label: 'Unused Amount',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    CREATED_BY: {
      label: 'Created By',
      visible: true,
    },

  });

  // Saved Filter View States
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const incomingPaymentsColumns = () => {
    const payoutColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <div onClick={() => {
      //       setShowViewPayout(true);
      //       setSelectedPayment(record);
      //     }}
      //     >
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={record?.tenant_seller_info?.seller_name || ' - '} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.approval_status).color }}>
      //             {Helpers.getStatusColor(record.approval_status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         <H3Text text={`Location - ${record?.tenant_info?.tenant_name}`} className="mobile-list__item-info" />
      //         <H3Text text={`Date - ${toISTDate(record?.payment_date).format('DD/MM/YYYY')}`} className="mobile-list__item-info" />
      //         <H3Text text={`Amount - ${MONEY(record?.amount || '0')}`} className="mobile-list__item-info" />
      //         <H3Text text={`Unused Amount - ${MONEY(record?.unused_amount || '0')}`} className="mobile-list__item-info" />
      //         <H3Text
      //           text={(
      //             <React.Fragment>
      //               Payment Status -&nbsp;
      //               <span style={{ color: Helpers.getStatusColor(record.payment_status).color }}>
      //                 {Helpers.getStatusColor(record.payment_status).text}
      //               </span>
      //             </React.Fragment>
      //           )}
      //           className="mobile-list__item-info"
      //         />
      //         <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </div>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.tenant_seller_info?.internal_slr_code || record?.internal_cust_code || 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.approval_status).color }}
                  text={Helpers.getStatusColor(record.approval_status).text?.toProperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Link to={`/vendors/view/${record?.seller_info?.seller_id}`} target="_blank">
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={`${record.tenant_seller_info?.seller_name || record?.customer_name}`?.trim() || ''}
                    />
                  </Link>
                </div>
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Payment Date - ${toISTDate(record?.payment_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Amount" />
                  )}
                >
                  <PRZText
                    text={MONEY((record.amount || '0'), record?.org_currency_info?.currency_code)}
                  />
                </Tooltip>
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Unused Amount" />
                  )}
                >
                  <PRZText
                    text={MONEY((record.unused_amount || '0'), record?.org_currency_info?.currency_code)}
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Payment Status" />
                  )}
                >
                  <div
                    className="mobile-list__card_footer__other-status"
                    style={{ backgroundColor: Helpers.getStatusColor(record.payment_status).color }}
                  >
                    {Helpers.getStatusColor(record.payment_status).text}
                  </div>
                </Tooltip>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedPaymentNew(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'DATE',
        render: (record) => (
          <div className="min-width-50">
            {toISTDate(record?.payment_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'left',
        className: !visibleColumns.DATE.visible ? 'display-none' : '',

      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.LOCATION.visible ? 'display-none' : '',

      },
      {
        title: 'REFERENCE #',
        render: (record) => <div className="min-width-85">{record?.payment_status === 'PAYMENT_SUCCESS' ? record?.utr_number : ''}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.REFERENCE_CODE.visible ? 'display-none' : '',

      },
      {
        title: 'RECEIVER NAME',
        render: (text, record) => {
          // Conditional rendering based on seller_id
          const displayTextVendor = `${record?.tenant_seller_info?.internal_slr_code} - ${record?.tenant_seller_info?.seller_name}`;
          const linkVendor = `/vendors/view/${record?.tenant_seller_info?.seller_id}`;

          // Conditional rendering based on customer_id
          const displayTextCustomer = `${record?.internal_cust_code} - ${record?.customer_name}`;
          const linkCustomer = `/sales/customer/view/${record?.customer_id}`;

          return (
            <div className="associated-entity min-width-100">
              <Link to={record?.customer_id ? linkCustomer : linkVendor} target="_blank">
                {record?.customer_id ? displayTextCustomer : displayTextVendor}
              </Link>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.VENDOR.visible ? 'display-none' : '',
      },
      {
        title: 'PAYMENT ACCOUNT',
        render: (text, record) => (
          <div className="min-width-130">
            {(record?.paid_through_account_details?.account_name === 'PICE' ? 'ONLINE' : record?.paid_through_account_details?.account_name) || 'CASH'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.MODE.visible ? 'display-none' : '',

      },
      {
        title: 'PAYMENT STATUS',
        render: (text, record) => <div className="qr__status min-width-115" style={{ backgroundColor: Helpers.getStatusColor(record.payment_status).color }}>{Helpers.getStatusColor(record.payment_status).text}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.PAYMENT_STATUS.visible ? 'display-none' : '',

      },
      {
        title: 'APPROVAL STATUS',
        render: (text, record) => <div className="qr__status min-width-115" style={{ backgroundColor: Helpers.getStatusColor(record.approval_status).color }}>{Helpers.getStatusColor(record.approval_status).text}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.APPROVAL_STATUS.visible ? 'display-none' : '',

      },
      {
        title: 'AMOUNT',
        dataIndex: 'due_at',
        render: (text, record) => (
          <div className="column-amount min-width-70">
            {MONEY(record?.amount)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.AMOUNT.visible ? 'display-none' : '',

      },
      {
        title: 'UNUSED AMOUNT',
        dataIndex: 'due_at',
        render: (text, record) => (
          <div className="column-amount min-width-115">
            {MONEY(record?.unused_amount)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.UNUSED_AMOUNT.visible ? 'display-none' : '',

      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },

      {
        title: 'CREATED BY',
        render: (record) => (
          <div className="min-width-85">
            <H3Text text={toISTDate(record?.created_at).format('DD/MM/YYYY')} className="column-date" />
            <H3Text text={`${record?.created_by_info?.first_name || ''} ${record?.created_by_info?.last_name || ''}`} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.CREATED_BY.visible ? 'display-none' : '',
      },
    ];

    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.filter((item) => item?.is_active)?.map((custom) => {
        payoutColumns.push({
          title: custom.field_name,
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }

    payoutColumns.push({
      title: '',
      className: 'list__actions-column',
      render: (record) => (
        <div className="list__actions">
          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              setShowViewPayout(true);
              setSelectedPayment(record);
            }}
          >
            View
          </div>
        </div>
      ),
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isPortrait,
    });
    return payoutColumns.filter((item) => !item.hidden);
  };
  // common 
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray?.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }
  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'vendor',
        filter_value: Helpers.getValueFromUrl('vendor') || '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }
  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'vendor',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },

  ], []);
  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.OUTGOING_PAYMENTS,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    const paymentId = new URLSearchParams(location.search).get('payment_outgoing');
    new URLSearchParams(location.search).delete('payment_outgoing');
    setSelectedFilterView(systemDefaultUserView);
    if (paymentId) {
      setShowViewPayout(true);
      setSelectedPayment({ payment_id: paymentId });
      history.push('/purchase/vendor-payouts');
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);


  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');
      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);
      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        // common state
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        // temp state
        setCurrentPage(tempFilterValues.page || 1);
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedSeller(Number(tempFilterValues.vendor) ? Number(tempFilterValues.vendor) : '');
        getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', () => { }, true);

      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);



  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-payout'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const pushParamsToUrl = (page, currentLimit, word, currentTenant, seller, paymentType, paymentMode, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (seller) url += `&vendor=${seller}`;
    if (paymentType) url += `&payment_type=${paymentType}`;
    if (paymentMode) url += `&payment_mode=${paymentMode}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedTenant, selectedSeller, selectedPaymentType, selectedPaymentMode, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getPaymentsOutgoing(Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), selectedTenant?.filter(
        (item) => !isNaN(item),
      )?.length > 0 ? selectedTenant?.join(',')
        : Helpers.getTenantEntityPermission(
          user?.user_tenants, Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ,
        )?.join(','), '', '', '', '', Helpers.getValueFromUrl('payment_type') || getPaymentsOutgoing, Helpers.getValueFromUrl('keyword'), '', Helpers.getValueFromUrl('vendor'));
    }
  }, [searchKeyword, currentPage, limit, selectedTenant, selectedSeller, showViewPayout, selectedPaymentType, selectedPaymentMode]);

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const emailsArray = selectedEmails;

    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const emailsString = emailsArray.join(',');
    const payload = {
      org_id: user?.tenant_info?.org_id,
      tenant_id: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      emails: emailsString,
      type: 'send_email',
      payment_type: 'OUTGOING',
      seller_id: Helpers.getValueFromUrl('vendor'),
    };
    if (!downloadPaymentOutgoingLoading) {
      // fileType, orgId, tenantId, grnId, grnEntityId, grnEntityType, status, tenantSellerId, selectedEntityType, searchKeyword, columns
      downloadPaymentOutgoing(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  return (
    <div className="doc-list__wrapper">
      <div className="ant-row">
        <div className="ant-col-md-24 ant-col-xs-24">
          <div className="doc-list__header-wrapper">
            <div className="doc-list__header-wrapper__left">
              <div className="section-search">
                <div className="doc-list__search-bar__wrapper">
                  <div className="section-search-bar">
                    <input
                      value={keyword}
                      placeholder="Search for Vendor Payout..."
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          getPaymentsOutgoing(1, 10, selectedTenant, null, null, null, null, selectedPaymentType, keyword, selectedSeller);
                          setSearchKeyword(e.target.value);
                          setCurrentPage(1);
                        }
                      }}
                      onChange={(event) => {
                        setKeyword(event.target.value);
                      }}
                    />
                    <H3Image
                      src={searchIcon}
                      className="section-search-bar__icon"
                      alt="search"
                      onClick={() => {
                        getPaymentsOutgoing(1, 10, selectedTenant, null, null, null, null, selectedPaymentType, keyword, '', selectedSeller);
                        setSearchKeyword(keyword);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="doc-list__header-wrapper__right">
              {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.CREATE, user) && (
                <div className="doc-list__buttons-wrapper">
                  <H3Button
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    text="+ Record New Payment"
                    onClick={() => history.push('/payments/create')}
                    customClass="add-button"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex-align-c" style={{ gap: '10px' }}>
            <UserSavedFilterViewSelector
              selectedFilterView={selectedFilterView}
              onChangeTab={(currentSelectedView) => {
                setSelectedFilterView(() => {
                  const currentSelectedViewFilters = currentSelectedView.filters;

                  const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                  const tempFilterValues = filterValue;
                  // temp states
                  setKeyword(tempFilterValues.keyword);
                  setSearchKeyword(tempFilterValues.keyword);
                  setLimit(tempFilterValues.limit);
                  setCurrentPage(1);
                  setSelectedTenant(tempFilterValues.tenant);
                  setSelectedSeller(Number(tempFilterValues.vendor) ? Number(tempFilterValues.vendor) : '');
                  getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', () => { }, true);
                  return currentSelectedView;
                });
              }}
              currentlyAppliedFilters={currentlyAppliedFilters}
              entityName={entityNameEnum.OUTGOING_PAYMENTS}
              setSavedFilterViews={(value) => setSavedFilterViews(value)}
              setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
              setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
              callback={() => {
                if (!isUserReadyInitial) setIsUserReadyInitial(true);
              }}
              systemDefaultUserView={systemDefaultUserView}
            />
            <div className="header__tags">
              {searchKeyword && (
                <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                  Search results for -
                  &nbsp;
                  <span><b><i>{searchKeyword}</i></b></span>
                </Tag>
              )}
              {selectedSeller && (
                <Tag closable onClose={() => { setSelectedSeller(''); setCurrentPage(1); }} color="#2d7df7">
                  Selected Vendor -
                  &nbsp;
                  <span><b>{sellers?.sellers?.filter((item) => item.seller_id === Number(selectedSeller))?.[0]?.seller_info?.seller_name}</b></span>
                </Tag>
              )}
              {selectedPaymentMode && (
                <Tag closable onClose={() => { setSelectedPaymentMode(''); setCurrentPage(1); }} color="#2d7df7">
                  Payment Account -
                  &nbsp;
                  <span>
                    <b>
                      {paymentModeResults?.filter((item) => item?.account_id === selectedPaymentMode)?.[0]?.account_name?.split('_')?.join(' ')?.toUpperCase()}
                    </b>

                  </span>
                </Tag>
              )}
              {selectedTenant && selectedTenant?.map((item, index) => (
                <div key={item}>
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                </div>

              ))}
            </div>
          </div>

          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    {`${paymentOutgoing?.count || '0'} Outgoing Payments`}
                  </div>
                  <div className="doc-list__table-header__right">
                    <div className="doc-list__filter-buttons">
                      {paymentOutgoing && paymentOutgoing?.count > 0 && (
                        <Popover
                          placement="bottom"
                          trigger="click"
                          title={<div className="download-btn-popover__title">Please provide your email address</div>}
                          open={openPopover}
                          onOpenChange={() => setOpenPopover(!openPopover)}
                          content={(
                            <React.Fragment>
                              <div>
                                <PRZSelect
                                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                  mode="tags"
                                  filterOption={false}
                                  value={selectedEmails}
                                  onChange={(value) => setSelectedEmails(value)}
                                  disabled={downloadPaymentOutgoingLoading}
                                  maxTagCount="responsive"
                                  style={{
                                    width: '300px',
                                    fontSize: '13px',
                                    height: 'auto !important',
                                  }}
                                >
                                  {selectedEmails.length > 0 ? (
                                    selectedEmails.map((item) => (
                                      <Option key={item} value={item}>
                                        {item}
                                      </Option>
                                    ))
                                  ) : (
                                    <Option key={user?.email} value={user?.email}>
                                      {user?.email}
                                    </Option>
                                  )}

                                </PRZSelect>
                              </div>
                              <div className="mg-top-10">
                                <H3Button
                                  text="Send"
                                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                  onClick={() => downloadHandler()}
                                  customClass="email-submit"
                                  isLoading={downloadPaymentOutgoingLoading}
                                  disabled={downloadPaymentOutgoingLoading}
                                >
                                  Send
                                </H3Button>
                              </div>
                            </React.Fragment>
                          )}
                        >
                          <div
                            className={`download-btn ${downloadPaymentOutgoingLoading ? 'download-btn__disabled' : ''}`}
                            onClick={() => { setOpenPopover(true); }}
                          >
                            <H3Text
                              text={(<FontAwesomeIcon icon={faDownload} />)}
                              className="action-button"
                            />
                          </div>
                        </Popover>
                      )}
                      <Dropdown
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        overlay={(
                          <div className="header__filter__container">
                            <div className="header__filter__container__title">
                              Apply Filters
                            </div>
                            <div className="filter__container filter__container-section">

                              <div className="filter__title"> Select Business Unit </div>

                              <TenantSelector
                                selectedTenant={selectedTenant}
                                showSearch
                                onChange={(value) => {
                                  setSelectedTenant(value);
                                }}
                                placeholder="Select Business Unit"
                                isMultiple
                                hideTitle
                                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ)}
                              />
                            </div>
                            <SelectSeller
                              selectedSeller={selectedSeller}
                              tenantId={selectedTenant}
                              onChange={(value) => {
                                setSelectedSeller(value?.seller_id);
                                setCurrentPage(1);
                              }}
                              customStyle={{}}
                              containerClass="filter__container filter__container-section"
                              inputClassName="no-class"
                              labelClassName="filter__title"
                              showAllSeller
                              mapSellerId
                            />

                            {/* <div className="filter__container inventory__header__section-status filter__container-section">
                              <div className="filter__title">Payment Account</div>
                              <Select
                                value={selectedPaymentMode}
                                onChange={(value) => {
                                  setSelectedPaymentMode(value);
                                }}
                                style={{ width: '100%' }}
                                placeholder="Select Payment Account"
                              >
                                {paymentModeResults?.map((item) => (
                                  <Option key={item?.account_id} value={item?.account_id}>
                                    {item?.account_name?.split('_')?.join(' ')?.toUpperCase()}
                                  </Option>
                                ))}
                              </Select>

                            </div> */}

                          </div>
                        )}
                      >

                        <div className="action-buttons">
                          <div className="action-button">
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                      </Dropdown>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                        localStorage.setItem('prcz-page-columns-payout', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-payout', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              )}
              showHeader
              loading={getPaymentsOutgoingLoading || savedFilterViewsLoading}
              size="small"
              columns={incomingPaymentsColumns()}
              dataSource={paymentOutgoing?.payments || []}
              currentPage
              scroll={!isMobileOrPortrait && !!paymentOutgoing?.payments?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
              sticky={!isMobileOrPortrait && !!paymentOutgoing?.payments?.length}
              pagination={
                {
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: paymentOutgoing ? paymentOutgoing?.count : 0,
                  pageSize: limit,
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                  },
                  position: ['bottomLeft'],
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }
              }
              bordered
            />
          </div>
        </div>
      </div>
      <Drawer
        open={showViewPayout}
        onClose={() => setShowViewPayout(false)}
        width="1080px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1020px' }}>
            <H3Text text="View Payment" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowViewPayout(false);
              }}
            />
          </div>
        </div>
        {/* <ViewPayment
          selectedPaymentId={selectedPayment?.payment_id}
          onClose={() => {
            setShowViewPayout(false);
          }}
          callback={() => {
            setShowViewPayout(false);
          }}
        /> */}
        <ViewOutgoingPayment
          selectedPaymentId={selectedPayment?.payment_id}
          onClose={() => {
            setShowViewPayout(false);
          }}
          callback={() => {
            setShowViewPayout(false);
          }}
        />
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedPaymentNew?.tenant_seller_info?.seller_name || selectedPaymentNew?.customer_name}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedPaymentNew?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedPaymentNew, MONEY, user })}
        />
      </Drawer>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, PaymentOutgoingReducers, SellerReducers, CFV2Reducers, PaymentModeReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPaymentsOutgoingLoading: PaymentOutgoingReducers.getPaymentsOutgoingLoading,
  paymentOutgoing: PaymentOutgoingReducers.paymentOutgoing,
  sellers: SellerReducers.sellers,
  getSellersLoading: SellerReducers.getSellersLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocVendorPayout,
  paymentModeResults: PaymentModeReducers.paymentModeResults,
  downloadPaymentOutgoingLoading: PaymentOutgoingReducers.downloadPaymentOutgoingLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentsOutgoing: (page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId) => dispatch(PaymentOutgoingActions.getPaymentsOutgoing(page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive) => dispatch(
    SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive),
  ),
  getPaymentMode: (accountType, callback) => dispatch(PaymentModeActions.getPaymentMode(accountType, callback)),
  downloadPaymentOutgoing: (payload, callback) => dispatch(PaymentOutgoingActions.downloadPaymentOutgoing(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutgoingPaymentsList));
